import { SYLLABUS_CONTENT_MODEL_CEC } from '@/constants'
import { Syllabus } from '@/kontent/content-types'
import { CustomSyllabusTab } from '@/types'
import { CecContentHide } from '@/types/cec'
export const shouldHideTabBasedOnCecContentHide = (
	syllabus: Syllabus,
	tabId: CustomSyllabusTab | CecContentHide,
) => {
	if (
		syllabus.elements.syllabus_content_model?.value[0]?.codename ===
		SYLLABUS_CONTENT_MODEL_CEC
	) {
		const hiddenCecTabs = syllabus.elements.cec_content_hide?.value.map(
			(item) => item.codename as CecContentHide,
		)

		if (hiddenCecTabs.includes(tabId as CecContentHide)) {
			return true
		}

		if (tabId === 'outcomes' && hiddenCecTabs.includes('content')) {
			return true
		}

		if (
			tabId === 'teaching-and-learning' &&
			hiddenCecTabs.includes('resources') &&
			hiddenCecTabs.includes('teaching_advices')
		) {
			return true
		}
	}
	return false
}

export const isCecSyllabus = (syllabus: Syllabus) => {
	return syllabus.elements.syllabus_content_model?.value.some(
		(t) => t.codename === SYLLABUS_CONTENT_MODEL_CEC,
	)
}
